import React, { useEffect, useState, useRef } from 'react';//useCallback
import { Container, Box, Grid, Typography } from '@mui/material';
// import Webcam from "react-webcam";
import QrScanner from 'qr-scanner';
// import { QrReader } from 'react-qr-reader';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import FooterMenu from 'Components/FooterMenu';

import mainStyles from 'Styles/mainStyles';
import useGlobalState from 'Hooks/useGlobalState';
import Alert from 'Components/Alert';
import useWindowSize from 'Hooks/useWindowSize';

const ScanDevice = () => {
	const classes = mainStyles();
	const [, dispatch] = useGlobalState();
	const navigate = useNavigate();
	const windowSize = useWindowSize();
	const { t } = useTranslation();

	const webcamRef = useRef(null);

	const [alertWrongOpen, setAlertWrongOpen] = useState(false);
	const [alertErrorOpen, setAlertErrorOpen] = useState(false);
	const [scanner, setScanner] = useState(null);

	useEffect(() => {
		dispatch({ headerTitle: t('scan.header'), device: null, deviceType: null, showMobileStepper: false, showBottomNavigation: true, bulkOnboarding: false });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dispatch]);

	useEffect(() => {
		async function startScanner() {
			// const scan = useCallback(() => {
			let qrScanner = null;
			console.log('startScanner');
			if (!webcamRef.current) return;
			// const imageData = webcamRef.current.getScreenshot();
			// QrScanner.scanImage(imageData, { returnDetailedScanResult: true, highlightScanRegion: true, highlightCodeOutline: true })
			// .then(result => console.log(result))
			// .catch(error => console.log(error || 'No QR code found.'));

			qrScanner = new QrScanner(
				webcamRef.current,
				result => {
					console.log(result);
					if(result.data !== '') {
						const resultParts = result.data.split('/');
						navigate('/' + resultParts[resultParts.length -1]);
					}
				},
				{
					returnDetailedScanResult: true,
					// highlightScanRegion: true,
					// highlightCodeOutline: true,
					maxScansPerSecond: 5,
					calculateScanRegion: (video) => ({
						x: 0,
						y: 0,
						width: video.videoWidth,
						height: video.videoHeight,
						downScaledHeight: 0,
						downScaledWidth: 0,
					})
				});
			qrScanner.start().then(async () => {
				console.log('started scanner');
			}).catch(console.error);

			setScanner(qrScanner);
		}

		if (!scanner) {
			startScanner();
		}

		// .scanImage(webcamRef, { returnDetailedScanResult: true })
		// 	.then(result => {
		// 		const resultParts = result.split('/');
		// 		if (resultParts[3] !== 'onboard') {
		// 			setAlertWrongOpen(true);
		// 		} else {
		// 			navigate('/' + resultParts[4] + '/' + resultParts[5]);
		// 		}
		// 	})
		// 	.catch(error => {
		// 		console.log(error);
		// 		//setAlertErrorOpen(true);
		// 	});


		return () => {
			if (scanner) {
				scanner.destroy();
				setScanner(null);
			}
		}

	}, [navigate, scanner]);

	// const cancel = () => {

	// }

	const closeAlert = () => {
		setAlertErrorOpen(false);
		setAlertWrongOpen(false);
	}

	return (
		<Container component="main" maxWidth="lg" className={classes.containerWithPadding} style={{ height: windowSize.height !== undefined ? windowSize.height - 20 : 0, overflow: 'scroll' }}>
			<Grid container justifyContent={'center'} alignItems='center'>
				<div className={classes.onboardContainer}>
					<Typography variant="h4" className={classes.title}>{t('Scan QR-koden på sensoren')}</Typography>
				</div>
				<div style={{ width: '90%', display: 'flex', justifyContent: 'center', borderRadius: 10, overflow: 'hidden', marginTop: 30 }}>
					<video id="qr-video" ref={webcamRef} style={{ width: '100%', maxHeight: 500, marginTop: 0 }} playsInline muted></video>
				</div>
				<div className={classes.onboardContainer}>
					<Typography variant="body2" className={classes.title}>{t('Registrer en sensor ved at scanne QR-koden. Du kan tilføje enheder i enhver rækkefølge. ')}</Typography>
				</div>
				<Link to="/manual" className={classes.link}>{t('Indtast sensor-ID manuelt ')}</Link>

				{/* <Button onClick={handleConfirm} variant="contained" className={classes.greenButton}>{t('Bekræft')}</Button> */}
			</Grid>

			
			{/* <Webcam
				style={{ width: '50%', marginTop: 30 }}
				ref={webcamRef}
				screenshotFormat="image/jpg"
				screenshotQuality={1}
				videoConstraints={{ facingMode: "environment" }}
			/> */}

			{/* <QrReader
				videoId="video"
				scanDelay={500}
				constraints={{ facingMode: 'environment' }}
				onResult={(result, error) => {
					if (!!result) {
						console.log(result.text);
						const resultParts = result.text.split('/');
						console.log(resultParts.length);

						if (resultParts[3] !== 'onboard') {
							// setAlertWrongOpen(true);
						} else if (resultParts.length === 6) {
							navigate('/' + resultParts[4] + '/' + resultParts[5]);
						}
					}

					if (!!error) {
						console.log(error);
					}
				}}
				style={{ width: '100%' }}
			/> */}

			<Box className={classes.buttonPanel} justifyContent="center">
				{/* <Button className={classes.greenButton} onClick={() => scan()}>Scan</Button> */}
				{/* <Button className={classes.redButton} onClick={() => cancel()}>Annuller</Button> */}
			</Box>

			<Alert text={t('scan.notRecognized')} visible={alertWrongOpen} handleClose={closeAlert} />
			<Alert text={t('scan.noQrFound')} visible={alertErrorOpen} handleClose={closeAlert} />
			<FooterMenu activeMenu={1} />
		</Container>
	)
}

export default ScanDevice;